module.exports = __webpack_public_path__ + "static/media/Dosmagulova K..c0f820cb.pdf";